<script>

import DemoBulder from './DemoBuilder'
import Text from '@@/text/vue/Text'
import Title from '@@/title/vue/Title'
import Link from '@@/link/vue/Link'
import Icon from '@@/icon/vue/Icon'
import Button from '@@/button/vue/Button'
import ButtonDial from '@@/button/vue/ButtonDial'
import Progress from '@@/progress/vue/Progress'
import Tooltip from '@@/tooltip/vue/Tooltip'
import Input from '@@/input/vue/Input'
import Figure from '@@/figure/vue/Figure'
import Frame from '@@/frame/vue/Frame'

import Float from '@@/float/vue/Float'
import List from '@@/list/vue/List'

export default {
    name: 'dkbr-demo',
    components: {
        'dkbr-demo-builder': DemoBulder,
    },
    data() {
        return {
            Elem: Figure,
            Elems: {Text, Title, Link, Icon, Button, ButtonDial, Progress, Tooltip, Input, Figure, Frame, Float, List,},
        }
    },
}
</script>

<template lang="pug">

div.dkbr-demo
    dkbr-button-dial(
        th="th2"
        posx="right"
        posy="bottom"
        dir="top"
        effect="fling"
        icon="play_for_work"
        iconFinal="add"
        md-direction="top"
        :isHover="false")
            div.dkbr-demo__menu
                dkbr-button.dkbr-demo__menu-item(
                    v-for="[name, El] of Object.entries(Elems)"
                    :key="name"
                    :text="name"
                    :isRaised="true"
                    :isPrimary="true"
                    @click.native="Elem = El")
    dkbr-demo-builder.dkbr-demo__content(
        v-if="El == Elem"
        v-for="[name, El] of Object.entries(Elems)"
        :key="name"
        :Elem="El")
</template>

<style lang="sass">

@import '~@/sass/root.sass'

.dkbr-demo
    &__menu
        +flex(column, wrap-reverse, flex-end, flex-start)
        +height-max(500px)
        +margin-r(20px)
        &-item
            +width(100px)
            +margin(100px)
    &__content
        width: 100vw
        height: 100vh
        margin: 0
</style>



// WEBPACK FOOTER //
// src/demo/vue/Demo.vue